"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearLoggingContext = exports.setLoggingContextAuthContext = exports.getLoggerContext = exports.createLoggingContext = void 0;
const logger_config_1 = require("./logger.config");
function createEmptyLoggerContext() {
    return {
        env: logger_config_1.getStage(),
        correlationId: undefined,
        requestId: undefined
    };
}
let globalLoggerContext = {
    context: createEmptyLoggerContext()
};
exports.createLoggingContext = (requestContext) => {
    let loggerContext = Object.assign({}, requestContext);
    globalLoggerContext.context = loggerContext;
    return loggerContext;
};
exports.getLoggerContext = () => {
    return globalLoggerContext.context;
};
exports.setLoggingContextAuthContext = (authContext) => {
    const loggerContext = exports.getLoggerContext();
    loggerContext.principalType = authContext.role;
    loggerContext.principalId = authContext.token;
    // loggerContext.featureSet = authContext.featureSet;
};
exports.clearLoggingContext = () => {
    globalLoggerContext.context = createEmptyLoggerContext();
};
//# sourceMappingURL=logger.context.js.map